import alertSignal from 'signals/Alert.signal';
import api from 'api/api';
import loaderSignal from '../signals/Loader.signal';
import { edoProgramRequestCursor } from '../signals/EdoProgramRequests.signal';
import userAccountSignal from '../signals/UserAccount.signal';

const LIMIT = 20;

export const fetchEdoProgramRequests = async (limit = LIMIT, status = '') => {
  loaderSignal.update({ isContentLoading: true });
  let options = {};
  if (status) {
    options = {
      take: limit,
      where: {
        status,
        ventureCapitalFirm: null,
        fundingProgram: {
          edoId: userAccountSignal.value.userData.account.edo.id,
        },
      },
      include: {
        documents: true,
        lender: true,
        fundingProgram: {
          include: {
            stats: true,
            edo: true,
            supportingDocuments: true,
            referenceProgram: {
              include: {
                programType: true,
              },
            },
            bankAccountProgramAccesses: {
              include: {
                bankAccount: true,
              },
            },
            platform: true,
          },
        },
        notes: true,
        watchables: true,
        logs: {
          include: {
            user: {
              select: {
                firstName: true,
                lastName: true,
              },
            },
          },
        },
      },
    };
  } else {
    options = {
      take: limit,
      where: {
        ventureCapitalFirm: null,
        fundingProgram: {
          edoId: userAccountSignal.value.userData.account.edo.id,
        },
      },
      include: {
        documents: true,
        lender: true,
        fundingProgram: {
          include: {
            stats: true,
            edo: true,
            supportingDocuments: true,
            referenceProgram: {
              include: {
                programType: true,
              },
            },
            bankAccountProgramAccesses: {
              include: {
                bankAccount: true,
              },
            },
            platform: true,
          },
        },
        notes: true,
        watchables: true,
        logs: {
          include: {
            user: {
              select: {
                firstName: true,
                lastName: true,
              },
            },
          },
        },
      },
    };
  }
  try {
    const programRequests = await api.get({
      path: '/programRequests',
      options,
    });
    if (programRequests.length === limit) {
      edoProgramRequestCursor.update(programRequests[limit - 1].id);
    } else {
      edoProgramRequestCursor.update(null);
    }
    return programRequests;
  } catch (error) {
    return alertSignal.update({
      type: 'notification',
      error,
      message: error.message,
    });
  } finally {
    loaderSignal.reset();
  }
};

export const paginateEdoProgramRequests = async (
  limit = LIMIT,
  status = ''
) => {
  const cursor = edoProgramRequestCursor.value;
  let options = {};
  if (!cursor) return;

  if (status) {
    options = {
      take: limit,
      skip: 1, // skip cursor
      cursor: {
        id: cursor,
      },
      where: {
        status,
        ventureCapitalFirm: null,
        fundingProgram: {
          edoId: userAccountSignal.value.userData.account.edo.id,
        },
      },
    };
  } else {
    options = {
      take: limit,
      skip: 1,
      cursor: {
        id: cursor,
      },
      where: {
        ventureCapitalFirm: null,
        fundingProgram: {
          edoId: userAccountSignal.value.userData.account.edo.id,
        },
      },
    };
  }

  try {
    loaderSignal.update({ isContentLoading: true });
    const programRequests = await api.get({
      path: '/programRequests',
      options,
    });

    if (programRequests.length === limit) {
      edoProgramRequestCursor.update(programRequests[limit - 1].id);
    } else {
      edoProgramRequestCursor.update(null);
    }
    return programRequests;
  } catch (error) {
    alertSignal.update({
      type: 'notification',
      message: error.message,
      error,
    });
    return [];
  } finally {
    loaderSignal.reset();
  }
};

// for ApplicationDetailsModal.helpers.ts since /EdoProgramRequest been removed
export const fetchAndSetEdoProgramRequests = async () => {
  try {
    loaderSignal.update({ isContentLoading: true });
    const programRequests = await api.get({
      path: '/programRequests',
    });
    return edoProgramRequestsSignal.update({ programRequests });
  } catch (error) {
    return alertSignal.update({
      type: 'notification',
      error,
      message: error.message,
    });
  } finally {
    loaderSignal.reset();
  }
};
